import { makeGetRequest } from 'owa-ows-gateway';
import { PremiumLegacyTenantResponse } from '../contracts/premiumLegacyTenantResponse';

const getPremiumLegacyTenantUrl: string = 'ows/api/beta/PremiumUser/legacytenant';

export async function getPremiumLegacyTenant(): Promise<PremiumLegacyTenantResponse> {
    let response = await makeGetRequest(getPremiumLegacyTenantUrl);
    return response;
}
